import React from 'react'
import { Box } from '@mui/material'
import { RoutesManager } from 'utils/routing/routesManager'
import { useQueryParams } from 'utils/hooks/useQueryParams'
import { NavigationBreadCrumbs } from 'components/appLayout/appNavigation/breadcrumbs/NavigationBreadCrumbs'
import { ContentGroup, DataGrid, EmptyState } from '@ketch-com/deck'
import { ReactComponent as EmptyStateIcon } from 'assets/icons/emptyState/EmptyStateVersions.svg'
import { cookieVersionsTabGridColumns } from './utils/purposesTabVersionsUtils'
import { usePurposeViewContext } from 'pages/policyCenter/purposes/view/context/PurposeViewContext'

export const PurposesTabVersions: React.FC = () => {
  const { purpose, versions } = usePurposeViewContext()
  const { queries, setQueryParam, removeQueryParam } = useQueryParams<{ version?: string }>()
  const { name, code, version } = purpose || {}

  const currentVersion = queries.version ? +queries.version : version

  return (
    <>
      <NavigationBreadCrumbs
        type="dark"
        items={[
          { title: 'Privacy Program', link: RoutesManager.policyCenter.root.getURL() },
          { title: 'Purposes', link: RoutesManager.policyCenter.purposes.root.getURL() },
          {
            title: name || code,
            link: RoutesManager.policyCenter.purposes.view.root.getURL({ code }),
          },
          { title: 'Versions' },
        ]}
      />

      <Box display="flex" flexDirection="column" gap={4}>
        <ContentGroup title="Version History" titleVariant="h3" variant="inner-page-header" />
        {!versions.length ? (
          <>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              padding={6}
              borderRadius="11px"
              bgcolor="bone.main"
            >
              <EmptyState
                title="No versions exist for the selected purpose"
                subTitle="As you make changes to this purpose, you can view that history here"
                customIcon={<EmptyStateIcon />}
              />
            </Box>
          </>
        ) : (
          <DataGrid
            sx={{
              padding: 'unset',
              height: 'auto',
            }}
            autosizeOnMount
            columns={cookieVersionsTabGridColumns(currentVersion || 0, removeQueryParam, setQueryParam)}
            disableChildrenSorting
            disableColumnMenu
            disableColumnPinning
            disableColumnReorder
            disableColumnResize
            disableRowHoverStates
            disableRowSelectionOnClick
            getRowId={row => row.ID}
            hideFooter
            rows={versions}
            getRowHeight={() => 'auto'}
          />
        )}
      </Box>
    </>
  )
}
